<div class="card-with-footer">
  <!-- Image Section -->
  <div class="card-with-footer-image">
    <img [src]="cardInfo.imageUrl" alt="Hero" class="img-fluid">
    <div class="image-overlay">
      <span class="image-text-cnt">
        <span class="card-category">{{cardInfo.badgeText}}</span>
        <h2 class="overlay-title">{{cardInfo.title}}</h2>
      </span>
    </div>
  </div>

  <!-- Content Section -->
  <div class="card-with-footer-body">
    <h2 class="webapp-title-secondary">{{cardInfo.subtitle}}</h2>
    <p class="card-subtitle text-muted">
      {{cardInfo.text}}
    </p>

    <!-- Footer Section -->
    <!-- <div class="card-footer d-flex align-items-center">
      <img src="../../assets/img/avatars/5.jpg" alt="Profile" class="profile-image rounded-circle">
      <button class="btn btn-outline-danger ms-auto">
        <i class="fas fa-heart"></i>
      </button>
    </div> -->
  </div>
</div>
